import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const WalletCardSkeleton = () => {
  return (
    <div className="col-sm-6 col-md-4 mt-3">
      <div className="my-wallet">
        <div className="walletSection">
          <div className="walletSection-lft">
            {/* Skeleton for the image */}
            <Skeleton circle={true} width={40} height={40} />
            <div className="walletSection-details">
              {/* Skeletons for the text */}
              <h4>
                <Skeleton width={150} />
              </h4>
              <p>
                <Skeleton width={180} />
              </p>
              <div className="wallet-exp">
                <Skeleton width={100} />
              </div>
            </div>
          </div>
        </div>
        <div className="myWallet-selection">
          {/* Skeletons for the links/text */}
          <a href="#javascript:;" className="text-decoration-underline d-block">
            <Skeleton width={50} />
          </a>
          <p>
            <Skeleton width={50} />
          </p>
        </div>
      </div>
    </div>
  );
};
